import { useTenant } from '../contexts/TenantContext'

interface AuditLogOptions {
  eventType: 'page_view' | 'document_download' | 'document_view' | 'login' | 'access_request' | 'settings_change' | 'content_update' | 'user_created' | 'email_captured'
  userId?: string
  userEmail?: string
  userName?: string
  userCompany?: string
  resourceType?: 'document' | 'page' | 'settings' | 'user' | 'subprocessor'
  resourceId?: string
  resourceName?: string
  metadata?: Record<string, any>
  severity?: 'info' | 'warning' | 'critical'
}

export const useAuditLog = () => {
  const { currentTenant } = useTenant()

  const logEvent = async (options: AuditLogOptions) => {
    if (!currentTenant) {
      console.warn('[useAuditLog] Cannot log audit event: no tenant context')
      return
    }

    try {
      const response = await fetch('/api/audit-log', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          tenantId: currentTenant.id,
          ...options
        })
      })

      // Always consume response body to prevent stream issues
      const data = await response.json()

      if (!response.ok) {
        console.error('[useAuditLog] API failed:', response.status, data)
        throw new Error(`Failed to log audit event: ${data.error || response.statusText}`)
      }

      return data
    } catch (error) {
      console.error('[useAuditLog] Full error:', error)
      // Don't throw - we don't want audit logging to break the app
    }
  }

  return { logEvent }
}
